import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {ModalDirective} from '@node_modules/ngx-bootstrap/modal';
import {AppComponentBase} from '@shared/common/app-component-base';
import {BasketArticleDto} from '@shared/service-proxies/service-proxies';
import _ from 'lodash';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';
import {OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';

@Component({
    selector: 'app-product-selector-modal',
    templateUrl: './product-selector-modal.component.html',
    styleUrls: ['./product-selector-modal.component.less']
})
export class ProductSelectorModalComponent extends AppComponentBase implements OnInit {

    @ViewChild('productSelectorModal', {static: true}) modal: ModalDirective;

    amount: number | undefined = 1;
    protected readonly keypad: (string | number)[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, '←', 0, 'Clear'];

    active = false;
    saving = false;

    article: BasketArticleDto;

    first = true;

    get quickAddAmounts(): number[] {
        if (!this.article) {
            return this.defaultQuickAddAmounts;
        }
        return this.article.advisedAmount;
    }

    constructor(
        injector: Injector,
        private _orderStateService: OrderStateService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    show(item: BasketArticleDto): ModalDirective {
        this.active = true;

        if (item) {
            this.article = item;
        }

        this.modal.show();
        return this.modal;
    }

    onShown(): void {
        //document.getElementById('ProjectName').focus();
    }

    close(): void {
        this.article = undefined;
        this.amount = 1;
        this.active = false;
        this.first = true;
        this.modal.hide();
    }

    onKeyPress(key: string | number) {
        if (this.first) {
            this.first = false;
            if (key === 'Clear') {
                this.amount = undefined;
            } else {
                this.amount = Number(`${key}`);
            }
            return;
        }

        if (key === 'Clear') {
            this.amount = undefined;
        } else if (key === '←') {
            if (this.amount.toString().length !== 1) {
                this.amount = Math.floor(this.amount / 10);
            } else if (this.amount.toString().length === 1) {
                this.amount = undefined;
            }
        } else {
            if (!this.amount) {
                this.amount = Number(`${key}`);
            } else {
                this.amount = Number(`${this.amount}${key}`);
            }
        }
    }

    addToCart() {
        const item = _.cloneDeep(this.article);
        item.quantity = this.amount;

        if (this.isGuided && this._orderStateService.isSelectPromotionState) {
            this.close();
            item.quantity = item.quantity  * -1;
            const data = {
                article: item,
                isSelectingArticles: true
            };
            abp.event.trigger('app.show.editLocalWarehouseModal', data);
        } else {
            this._addItemToBasket(item);
            this.resetQuantity(this.article);
        }
    }

    addToCartAndGoNext() {
        alert(`Added ${this.amount} to cart and proceeding.`);
    }

    addToBasket(article: BasketArticleDto) {
        const item = _.cloneDeep(article);
        if (this.isGuided && this._orderStateService.isSelectPromotionState) {
            this.close();
            item.quantity = item.quantity * -1;
            const data = {
                article: item,
                isSelectingArticles: true
            };
            abp.event.trigger('app.show.editLocalWarehouseModal', data);
        } else {
            this._addItemToBasket(item);
            this.close();
        }
    }

    private _addItemToBasket(article: BasketArticleDto) {
        const item = _.cloneDeep(article);

        this.webshopService.addItem(item);
        this.resetQuantity(this.article);
    }

    toggleItemDetailModal() {
        abp.event.trigger('app.toggle.itemDetailModal', this.article);
    }

}
